import * as actionTypes from './../actions/diagnosesAction';

const initialState = {
  selected: [],
  selectedData: {},
  selectedIds: [],
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      let newSelectedData = {...state.selectedData};
      newSelectedData[state.data.data[action.selected].id]=state.data.data[action.selected].label;
      return {
        ...state,
        selected: [...state.selected, action.selected],
        selectedIds: [...state.selectedIds, state.data.data[action.selected].id],
        selectedData: newSelectedData,
      };
    case actionTypes.REMOVE:
      const index = state.selected.indexOf(action.removed);
      let selectedArray = [...state.selected];
      let selectedIdsArray = [...state.selectedIds];
      let newSelectedData2 = {...state.selectedData};
      if (index > -1) {
        selectedArray.splice(index, 1);
        selectedIdsArray.splice(index, 1);
        delete newSelectedData2[state.data.data[action.removed].id];
      }
      return {
        ...state,
        selected: selectedArray,
        selectedIds: selectedIdsArray,
        selectedData: newSelectedData2,
      };
    case actionTypes.ORDER:
      let newSelected = [];
      action.orderedArray.map((value) => {
        newSelected.push(value.key);
      });
      let newSelectedIds = [];
      action.orderedArray.map((value) => {
        newSelectedIds.push(state.data.data[value.key].id);
      });
      return {
        ...state,
        selected: newSelected,
        selectedIds: newSelectedIds,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: [],
        selectedIds: [],
        selectedData: {},
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
